// Custom implementation to replace Rails confirm dialogs with Bootstrap modals

// Function to initialize the confirm modal
function initializeRailsConfirmModal() {
  // Only proceed if Rails UJS is loaded
  if (typeof Rails === 'undefined') {
    console.warn('Rails UJS not loaded, skipping confirm modal setup');
    return false;
  }

  // Default settings - can be overridden
  window.railsConfirmModal = {
    defaults: {
      title: 'Please Confirm',
      commit: 'OK',
      cancel: 'Cancel'
    },
    setDefaults: function (options) {
      Object.assign(this.defaults, options);
    }
  };

  // Override Rails.confirm to use Bootstrap modal
  Rails.confirm = function (message, element) {
    console.log('Rails.confirm called with message:', message);

    // Create a unique ID for this modal
    const modalId = 'confirm-modal-' + Date.now();

    // Get current defaults
    const defaults = window.railsConfirmModal.defaults;

    // Build the modal HTML
    const modalHtml = `
      <div class="modal fade" id="${modalId}" tabindex="-1" role="dialog" aria-labelledby="${modalId}-label" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="${modalId}-label">${defaults.title}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              ${message}
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">${defaults.cancel}</button>
              <button type="button" class="btn btn-danger confirm-button">${defaults.commit}</button>
            </div>
          </div>
        </div>
      </div>
    `;

    // Add modal to body
    document.body.insertAdjacentHTML('beforeend', modalHtml);

    // Get the modal element
    const modal = document.getElementById(modalId);
    const $modal = $(modal);

    console.log('Modal added to DOM with ID:', modalId);
    console.log('Modal element found:', modal !== null);

    // Flag to track if confirmed
    let confirmed = false;

    // Handle confirm button click
    modal.querySelector('.confirm-button').addEventListener('click', function () {
      confirmed = true;
      $modal.modal('hide');

      // Re-trigger the action without confirmation
      const event = new Event('click', { bubbles: true, cancelable: true });

      // Temporarily remove data-confirm to avoid infinite loop
      const originalConfirm = element.getAttribute('data-confirm');
      element.removeAttribute('data-confirm');

      // Dispatch the event
      element.dispatchEvent(event);

      // Restore data-confirm
      if (originalConfirm) {
        element.setAttribute('data-confirm', originalConfirm);
      }
    });

    // Clean up modal after it's hidden
    $modal.on('hidden.bs.modal', function () {
      modal.remove();
    });

    // Show the modal
    $modal.modal('show');
    console.log('Modal show called');

    // Return false to prevent the default action
    // The action will be re-triggered if user confirms
    return false;
  };

  console.log('Rails confirm modal initialized');
  return true;
}

// Try to initialize immediately if Rails is already loaded
if (typeof Rails !== 'undefined' && !window.railsConfirmModalInitialized) {
  window.railsConfirmModalInitialized = initializeRailsConfirmModal();
}

// Also try on DOMContentLoaded in case Rails loads later
document.addEventListener('DOMContentLoaded', function () {
  if (!window.railsConfirmModalInitialized) {
    window.railsConfirmModalInitialized = initializeRailsConfirmModal();
  }
});

// And try again after a short delay to handle async loading
setTimeout(function () {
  if (!window.railsConfirmModalInitialized) {
    window.railsConfirmModalInitialized = initializeRailsConfirmModal();
  }
}, 100);
